module.exports = __webpack_public_path__ + "img/Group 12@2x.58dc5ee4.png";